import CreateStoreForm from './CreateStoreForm';

export default CreateStoreForm;



// WEBPACK FOOTER //
// ./src/scenes/EditStore/components/CreateStoreForm/index.ts